"use client";

import { setCookie } from "cookies-next/client";

import { SIGNUP_PREFILL_COOKIE_KEYS } from "./constants";
import { CountryOfIncorporationValues } from "./eligibility-constants";

/** Reverse lookup: display label → country code (US, GB, …). */
const COUNTRY_LABEL_TO_CODE = Object.fromEntries(
  Object.entries(CountryOfIncorporationValues).map(([code, label]) => [
    label,
    code,
  ])
) as Record<string, keyof typeof CountryOfIncorporationValues>;

/** Apply-now dropdown includes countries outside the eligibility funnel enum. */
const APPLY_NOW_COUNTRY_LABEL_TO_CODE: Record<string, string> = {
  ...COUNTRY_LABEL_TO_CODE,
  "New Zealand": "NZ",
};

function getSignupCookieDomain(): string | undefined {
  if (process.env["NEXT_PUBLIC_VERCEL_ENV"] === "preview") {
    return process.env["NEXT_PUBLIC_VERCEL_BRANCH_URL"];
  }
  return ".wayflyer.com";
}

export interface SignupPrefillCookieValues {
  revenue?: number;
  countryLabel?: string;
}

/**
 * Sets first-party cookies consumed by app.wayflyer.com signup prefill.
 * Replaces the deprecated eligibility-funnel `setAppCookies` for apply-now flows.
 */
export function setSignupPrefillCookies({
  revenue,
  countryLabel,
}: SignupPrefillCookieValues): void {
  const domain = getSignupCookieDomain();
  const baseOptions = {
    domain,
    secure: process.env.NODE_ENV === "production",
    sameSite: "strict" as const,
  };

  if (revenue != null && Number.isFinite(revenue)) {
    setCookie(SIGNUP_PREFILL_COOKIE_KEYS.revenue, String(revenue), baseOptions);
  }

  if (countryLabel) {
    const countryCode =
      APPLY_NOW_COUNTRY_LABEL_TO_CODE[countryLabel] ??
      COUNTRY_LABEL_TO_CODE[CountryOfIncorporationValues.OTHER];
    setCookie(
      SIGNUP_PREFILL_COOKIE_KEYS.countryOfIncorporation,
      countryCode,
      baseOptions
    );
  }
}
